import config from './config';

const getRonaeleOrderDetailsUrl = (siteId, orderNumber) => `${config.ronaeleBaseUrl}/OrderManagement/Order/Detail/?orderId=${orderNumber}&siteId=${siteId}`;

export default getRonaeleOrderDetailsUrl;
